export enum EmailVerificationEmailType {
  Link = 'Link',
  Code = 'Code',
}
